<template>
	<h3
		v-if="showPageCount"
		class="configurator-additional-info">
		<strong>{{ pageCount }}</strong> pagina's <span v-if="allPageCounts.altered">({{ allPageCounts.file }} pdf-pagina's)</span>
	</h3>
</template>

<script>
export default {
	name: "PriceAmount",
	computed: {
		pageCount () {
			return this.$store.getters.getPageCount;
		},
		isPrintSidesCountChoice () {
			return this.$store.getters.isPrintSidesCountChoice;
		},
		showPageCount () {
			return !this.isPrintSidesCountChoice && this.pageCount != null && this.pageCount > 1;
		},
		allPageCounts () {
			return this.$store.getters.getAllPageCounts;
		}
	}
};
</script>



// WEBPACK FOOTER //
// src/components/element/price-pages.vue